<template>
  <div>
    <FrmManageEquipments
      show-select=true
      v-bind:selected-equipment="selectedEquipments"
      v-on:item-selected="selectedCallback"
    ></FrmManageEquipments>
  </div>
</template>


 <style lang="">
</style> 
<script>
import FrmManageEquipments from "../../Management/FrmManageEquipments";

export default {
  props: ["eventInfo","events"],
  components: {
    FrmManageEquipments,
  },
   watch:{
    eventInfo:function(value,old){
      console.debug("value");
      console.debug(value);
       this.selectedEquipments=value.risorseIntervento.filter((r)=>r.risorsa.tipo=="Attrezzatura").map((r)=>r.risorsa);
      console.debug("this.selectedEquipments",this.selectedEquipments);
    }
  },
  data: () => ({
    selectedEquipments: [ ],
  }),
  methods: { 
    
    GetSelectedResources(){
        return this.selectedResources;
    },
    selectedCallback: function (selectedItems) {
      this.eventInfo.risorse=this.eventInfo.risorse.filter((r)=>r.tipo!="Attrezzatura");
      for(let i=0;i<selectedItems.length;i++)
        this.eventInfo.risorse.push(selectedItems[i]);
      console.log(selectedItems);
      // this.selectedEquipments=selectedItems;
    },
  },
};
</script>

